import React from 'react';

const Replies = (props)=>{
    console.log(props);
    if(props.replies){
        return(
            <div>
                {props.replies.map(reply => {
                        let r = Math.random();
                        return (
                            <div className="card my-3 shadow-sm" key={reply.user+r}>
                                <div className="p-2" style={{ borderLeft: "solid 3px #65cdf0" }}>
                                    <span className="mr-2"><img src="/assests/images/user.png" height="40" alt="user"></img></span>
                                    <p className="mb-0" style={{ color: "#65cdf0", fontSize: "1.25em" }}>{reply.user}</p>
                                    
                                    <div className="card-text">
                                        {reply.comment}
                                    </div>
    
                                </div>
                            </div>
                        )
                    })}
            </div>
        )
    }
    else{
        return(
            <div></div>
        )
    }
    
}

export default Replies;